import logger from 'Jsx/Utils/logger';

enum TYPES {
  MIXPANEL = 'MIXPANEL',
}

function crehanaTracking(type: TYPES, ...options) {
  if (type === TYPES.MIXPANEL) {
    if (process.env.NODE_ENV === 'development') {
      logger({
        title: 'Deprecated Util function',
        content:
          "Don't use this util to send mixpanel events. Instead use the Jsx/Utils/mixpanelTracking util. It has a better implementation.",
        type: 'warn',
      });
    }

    try {
      // TODO: Replace this with the native mixpanel api
      // Create a custom UI-component to log tracks
      window.track(...(options as [string, any]));
    } catch (error) {
      console.log('Error to send track to mixpanel', error);
    }
  } else {
    // TODO: Move user activity track here (????)
    console.error('Error: Missing track type.');
  }
}

crehanaTracking.TYPES = TYPES;

export default crehanaTracking;
